/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartItem_item$ref = any;
export type CartItems_localItems$ref = any;
export type CartItems_localItems = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly id: string;
            readonly serviceId: string | null;
            readonly " $fragmentRefs": CartItem_item$ref;
        } | null;
    } | null> | null;
    readonly " $refType": CartItems_localItems$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartItems_localItems",
    "type": "ItemsConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemsEdge",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "id",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "serviceId",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "CartItem_item",
                            "args": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'ccc34ad7907863abb03b5f0c46fbaf73';
export default node;
